import { connect } from 'react-redux';
import { compose } from 'redux';

import { requestUploadContactFile as requestUploadContactFileAction } from 'actions/upload';
import { requestAddRelations as requestAddRelationsAction } from 'actions/user';
import { closeDrawer } from 'actions/drawer';
import * as formTypes from 'types/form';
import * as drawerTypes from 'types/drawer';
import injectValidators from 'components/Shared/Forms/injectValidators';

import InvitationsBasic from './index';

const mapStateToProps = () => ({
    initialValues: {
        emails: []
    }
});

const mapDispatchToProps = dispatch => ({
    requestUploadContactFile: (files, change, prevEmails) => dispatch(
        requestUploadContactFileAction(files, change, prevEmails)
    ),
    requestAddRelations: () => dispatch(
        requestAddRelationsAction(formTypes.inviteExternalEmailForm)
    ),
    onSubmit: ({ emails }, form) => {
        if (emails?.length) {
            dispatch(requestAddRelationsAction(emails));
            dispatch(closeDrawer(drawerTypes.DRAWER_INVITE_EXTERNAL_EMAILS));
            form.reset();
        }
    },
    onClose: () => dispatch(closeDrawer(drawerTypes.DRAWER_INVITE_EXTERNAL_EMAILS))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    injectValidators
)(InvitationsBasic);
